import axios from "axios";

export default function downloadBlob(url, download) {
    const newReq = axios.create({
        baseURL: '/',
        responseType: 'blob'
    })

    newReq.get(url, {
            responseType: 'blob'
        })
        .then(response => {
            const blob = new Blob([response.data])
            const link = document.createElement('a')

            link.href = URL.createObjectURL(blob)
            link.download = download
            link.click()
            URL.revokeObjectURL(link.href)
        })
}